__turbopack_context__.v({
  "heading": "features-module__HwOQCW__heading",
  "mainHeading": "features-module__HwOQCW__mainHeading",
  "subClass": "features-module__HwOQCW__subClass",
});
